import { Link } from "react-router-dom";

export const SIROD_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_6f2e58c6-9f2d-459e-a5a3-be9bcea3f577/artifacts/wabivdrr_sirod-secur-logo.png";

export const Logo = ({ size = 56, withText = true, dark = true, compact = false, to = "/" }) => {
  const inner = (
    <div className="flex items-center gap-3">
      <img
        src={SIROD_LOGO_URL}
        alt="Sirod Secur"
        style={{ width: size, height: size, objectFit: "contain" }}
        data-testid="sirod-logo"
      />
      {withText && (
        <div className="leading-tight">
          <div style={{ fontSize: compact ? 18 : 20, fontWeight: 500, color: dark ? "#fff" : "#0D1B2A", letterSpacing: "0.02em" }}>
            Sirod Secur
          </div>
          <div style={{ fontSize: compact ? 11 : 12, color: "#8CA0B8" }}>
            Protection you can trust
          </div>
        </div>
      )}
    </div>
  );
  if (!to) return inner;
  return (
    <Link to={to} className="inline-flex" data-testid="logo-home-link" aria-label="Go to Sirod Secur home">
      {inner}
    </Link>
  );
};
